import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { InvoicePatient, InvoicePrivateClient } from '../../../models/invoices';

@Component({
  selector: 'app-invoices-private-clients',
  standalone: true,
  imports: [
    SharedModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './invoices-private-clients.component.html',
  styleUrl: './invoices-private-clients.component.scss',
})
export class InvoicesPrivateClientsComponent {
  @Input() privateClients: InvoicePrivateClient[] = [];
  @Input() patients: InvoicePatient[] = [];
  @Input() isLoading: boolean = false;
  @Output() togglePanel = new EventEmitter<InvoicePrivateClient>();
  @Output() deleteRequest = new EventEmitter<InvoicePrivateClient>();

  displayedColumns: string[] = [
    'nomeCliente',
    'codiceFiscale',
    'paziente',
    'actions',
  ];

  modifyClient(client: InvoicePrivateClient) {
    this.togglePanel.emit(client);
  }

  deleteClient(client: InvoicePrivateClient) {
    this.deleteRequest.emit(client);
  }
}
